import React from "react";
import Hero from "../../components/Hero";
import NobodyDieBand from "../../components/NobodyDieBand";
import OurImpact from "../../components/OurImpact";
import WhyThisWorkMatters from "../../components/WhyThisWorkMatters";
import RealStories from "../../components/RealStories";
import HowWeCreateChange from "../../components/HowWeCreateChange";
import CollaboratingWithLeaders from "../../components/CollaboratingWithLeaders";
import SeeKrfImpact from "../../components/SeeKrfImpact";
import GetInvolved from "../../components/GetInvolved";

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <NobodyDieBand />
      <OurImpact
        heading="Our Impact"
        subtitle="Creating measurable change through education, preparedness, and community partnerships."
      />
      <WhyThisWorkMatters />
      <RealStories />
      <HowWeCreateChange />
      <CollaboratingWithLeaders
        heading="Collaborating With Leaders"
        accent="Who Share Our Mission"
        uppercaseHeading={true}
      />
      <SeeKrfImpact />
      <GetInvolved />
    </>
  );
};

export default Home;
